export default {
  route: {
    '爱乐教': 'easyteaching',
    '首页': 'Home',
    '登录': 'Log In',
    '幼儿园管理': 'Kindergarten',
    '集团管理': 'Group',
    '班级管理': 'Class',
    '地点管理': 'Place',
    '统计管理': 'Statistics',
    '用户管理': 'User',
    '专家与教师绑定': '"Expert & Teacher" Binding',
    '学生与家长绑定': '"Student & Parent" Binding',
    '园长与幼儿园绑定': '"Principal & Kindergarten" Binding',
    '专业老师与幼儿园绑定': '"Subject Teacher & Kindergarten" Binding',
    '保健医与学生绑定': '"Doctor & Student" Binding',
    '校车老师与校车绑定': '"Teacher & School Bus" Binding',
    '学生管理': 'Student',
    '学生档案': 'Student Profile',
    '学生考勤': 'Student Attendance',
    '学生校车考勤': 'School Bus Attendance',
    '假条补交': 'Absence Notes',
    '学生评量': 'Assessment',
    '教学管理': 'Teaching',
    '轶事记录': 'Class Observations',
    '课程记录': 'Course Records',
    '教案': 'Lesson Plans',
    '教学记录': 'Teaching Records',
    '学生作品': 'Arts & Crafts',
    '专家点评率': 'Evaluation Rate by Supervisor',
    '预设教案': 'Preset Lesson Plans',
    '培训资料管理': '培训资料管理',
    '家庭作业': 'Homeworks',
    '轶事记录评价': 'Comments on Class Observations',
    '课程记录评价': 'Comments on Course Records',
    '叮嘱反馈': 'Feedback on Notifications',
    '关怀问候反馈': 'Feedback on Updates & Reminders',
    '状态信息查询': 'Status Inquiry',
    '日常应用': 'Daily Section',
    '服药单': 'Medications',
    '校园通知': 'Announcements',
    '请销假': 'Absence Notes',
    '叮嘱': 'Notifications',
    '关怀问候': 'Updates & Reminders',
    '健康日报': 'Health Reports',
    '表格模板': 'Table Template',
    '表格管理': 'Forms',
    '托婴': 'Baby-sitting Section',
    '宝贝情绪': 'Mood',
    '三餐辅食': 'Meal Records',
    '日饮水量': 'Hydration Reports',
    '健康记录': 'Health Records',
    '校车管理': 'School Bus',
    '资料下载': 'Material Download',
    '外部设备管理': 'Hardware Managment',
    '磊盛人脸识别设备管理': 'Lesun Face Device',
    '厂拍人脸识别设备管理': 'Camera Park Face Device',
    '学生IC卡管理': 'Student IC Card',
    '招生小程序': '招生小程序',
    '财务': 'Finance',
    '学费单模板': 'Tuition Fee Templates',
    '学费单': 'Tuition Fees',
    '退费计算方法': 'Refund Caculations',
    '学费档案': 'Tuition Fee Records',
    '工资单': 'Payrolls',
    '评量管理': 'Assessment',
    '类别与指标': 'Categories & Objectives',
    '评量清单管理': 'Assessment Checklists',
    '班级圈': 'Moments',
    '教师打卡设置': 'Punch Settings',
    '教师打卡记录': 'Punch Records',
    '学园手册': 'Student Manual',
    '客户信息': 'Customer Info',
    '业财对账': 'Reconciliation',
    '周报': 'Weekly Report',
    '收费标准': 'Charging Standard',
    '班级状况': 'Class Situation',
    '招生年度计划': 'Annual Plan',
    '客户线索与商机': 'Clue & Opportunity',
    '客户来源分析': 'Customer Source Analysis',
    '实际招生人数分析': 'Actual Enrollment Analysis',
    '退园人数分析': 'Drop Out Analysis',
    '招生': 'Admission',
    '个人信息保护': 'Personal Info Protection',
    '数据处理': 'Data Processing',
    '萤石监控设备管理': 'EZVIZ Camera'
  },
  role: {
    '园长': 'Principal',
    '专家': 'Supervisor',
    '教师': 'Teacher',
    '家长': 'Parent',
    '幼儿园管理员': 'Kindergarten Admin',
    '超级管理员': 'Super Admin',
    '保健医': 'Doctor',
    '校车老师': 'School Bus Teacher',
    '集团领导': 'Investor',
    '教育局领导': 'Governmental Official',
    '专业老师': 'Subject Teacher',
    '招生老师': 'Admission Teacher',
    '财务': 'Financial Staff',
    '集团管理员': 'Group Admin',
    '集团招生老师': 'Group Admission',
    '用户id': 'User Id'
  },
  login: {
    title: 'Log In',
    '退出': 'Log Out'
  },
  placeholder: {
    '提示': 'Tips',
    '状态': 'Status',
    '请先保存后再预览，确认要预览吗？': 'Please save before viewing. Are you sure you want to preview?',
    '请确认是否保存，确定要关闭吗？': 'Are you sure you want to save? Sure you want to close i?',
    '确认要提交吗？': 'Are you sure you want to submit?',
    '确定要删除吗？': 'Are you sure you want to delete?',
    '确定要删除所选项吗？': 'Are you sure you want to delete all?',
    '确定要下载所选项吗？': 'Are you sure you want to download all?',
    '确定要下载所选学生的数据吗？': 'Are you sure you want to download the data of the student?',
    '确定要发送吗？': 'Are you sure you want to send?',
    '确定要删除图片吗？': 'Are you sure you want to delete?',
    '请选择所要删除的对象': 'Please select the objects you want to delete',
    '请选择所要下载的对象': 'Please select the objects you want to download',
    '追加成功': 'Successfully Added',
    '保存成功': 'Successfully Saved',
    '删除成功': 'Successfully Deleted',
    '编辑成功': 'Successfully Edited',
    '添加成功': 'Successfully Added',
    '审核成功': 'Approved',
    '更新成功': 'Successfully Updated',
    '提交成功': 'Successfully Submit',
    '草稿保存成功': 'Successfully Saved as Draft',
    '请先保存': 'Please Save',
    '请选择': 'Please Select',
    '请输入': 'Please Enter',
    '请选择学生': 'Please select student',
    '请选择日期': 'Please select date',
    '请选择班级': 'Please select class',
    '请选择时间': 'Please select time',
    '请选择集团': 'Please select Group',
    '请选择幼儿园': 'Please select kindergarten',
    '请选择状态': 'Please select status',
    '请选择名称': 'Please select title',
    '请选择园长': 'Please choose principal',
    '请选择专业老师': 'Please choose subject teacher',
    '请选择学生搜索': 'Please search by student',
    '请选择班级搜索': 'Please search by class',
    '请选择幼儿园搜索': 'Please search by kindergarten',
    '请选择集团搜索': 'Please search by Group',
    '请选择标题搜索': 'Please search by title',
    '请选择校车老师搜索': 'Please search by school bus teacher',
    '请选择校车搜索': 'Please search by school bus',
    '请选择教师名称搜索': 'Please search by teacher',
    '请选择版本': 'Please search by version',
    '请添加内容': 'Please add content',
    '请输入园长搜索': 'Please enter a name and search',
    '请输入标题': 'Please enter a title',
    '请输入学生姓名搜索': 'Please enter a student name and search',
    '请输入标题搜索': 'Please enter a title and search',
    '请输入内容搜索': 'Please enter content and search',
    '请输入学生姓名': 'Please enter student name',
    '请输入内容': 'Please enter content',
    '请输入地点名称': 'Please enter a location',
    '无图片显示': 'No Picture Display',
    '选择日期': 'Select Date',
    '选择月份': 'Select Month',
    '请选择开始日期': 'Start',
    '请选择结束日期': 'End',
    '提示：排序值越大，文件位置越靠前': 'Tips: the larger the sort value, the privious the file ranked.',
    '暂不支持上传视频': 'Upload video is not supported at the moment',
    '请输入托班总分': 'Please input the total score of the Pre class',
    '请输入小班总分': 'Please input the total score of the Junior class',
    '请输入中班总分': 'Please input the total score of the Middle class',
    '请输入大班总分': 'Please input the total score of the Senior class',
    '密码提示': 'Please enter password',
    '密码强度提示': 'The minimum length of the password is 8, and it must contain three of the four characters: upper and lower case alphabet, numbers and symbols(Special character combinations such as continuous numbers are not allowed). If the above conditions are not met, the user needs to change the password when logging in for the first time',
    '密码强度提示2': 'The minimum length of the password is 8, and it must contain three of the four characters: upper and lower case alphabet, numbers and symbols(Special character combinations such as continuous numbers are not allowed)',
    '密码': 'Password',
    '手机提示': 'Please enter phone number',
    '手机': 'Phone Number',
    '只能上传mp4文件': 'Only MP4 files can be uploaded',
    '学生国籍不能为空': 'Student nationality can not be empty',
    '学生照片不能为空': 'Student photo can not be empty',
    '父亲姓名不能为空': 'Dad name can not be empty',
    '母亲姓名不能为空': 'Mom name can not be empty',
    '父亲单位与职位不能为空': 'Dad company and position can not be empty',
    '母亲单位与职位不能为空': 'Mom company and position can not be empty',
    '父亲电子邮件不能为空': 'Dad email can not be empty',
    '母亲电子邮件不能为空': 'Mom email can not be empty',
    title: 'Please enter a title',
    // ------------------------
    '家长或学生姓名': 'Parents’ or Students’ Names',
    '请先上传文件': 'Please upload the file first',
    '请先选择文件': 'Please select a file first',
    '是否保存上传文件?': 'Do you want to save the uploaded file?',
    '输入用户名称搜索': 'Enter the user’s name and search',
    '选择集团搜索': 'Please search by Group names',
    '选择幼儿园搜索': 'Please search by kindergarten names',
    '选择班级搜索': 'Please search by class',
    '选择学生搜索': 'Please search by students ',
    '选择角色搜索': 'Please search by roles',
    '真实姓名': 'Real Name',
    '初始密码': 'New Password',
    '确认密码': 'Confirm Password',
    '性别': 'Gender',
    '是否启用': ' Enable',
    '邮箱': 'Email',
    '集团': 'Group',
    '幼儿园': 'Kindergarten',
    '班级': 'Class',
    '角色': 'Role',
    '默认角色': 'Default Role',
    '初始积分': 'Initial Bonus Points',
    '学生': 'Student',
    '正常金额': 'Normal Amount',
    '折扣': 'Discount',
    '折后金额': 'Amount After Discount',
    '入学日期': 'Date of Enrollment',
    '退款天数设置必须填写完整': 'Days for refund set-up must be completed',
    '项目名称和数值不能为空': 'Item Names & Number/Amount cannot be empty',
    '请添加缴费项目': 'Please add payment items',
    '请填写每个月的天数': 'Please add number of days per-month',
    'IC卡号不能为空': 'IC card number cannot be empty',
    '请选择项目名称': 'Please select an item name',
    '订单编号': 'Order Number',
    '订单名称': 'Order Name',
    '付款金额': 'Amount for Payment',
    '付款时间': 'Time',
    '是否通知所有未通知的家长缴费?': 'Are you sure to inform all the parents who have not been informed about the payment?',
    '通知成功': 'Informed Successfully',
    '是否通知家长缴费?': 'Are you sure to inform parents of the unpaid bills?',
    '是否确认此学费单？': 'Do you want to confirm this tuition bill?',
    '确认缴费单成功!': 'Payment confirmed successfully!',
    '确定要删除吗?': 'Are you sure you want to delete?',
    '0-100，例：7折对应的值是30': 'Example: The corresponding value of 30% off is 30',
    '学生不能为空': 'Student cannot be empty',
    '学生姓名不能为空': 'Name cannot be empty',
    '学生姓名搜索': 'Student name search',
    '标题不能为空': 'Title cannot be empty',
    '标题': 'Title',
    '新建': 'New',
    '开始日期': 'Start date',
    '结束日期': 'End date',
    '请上传视频文件': 'Please upload video',
    '除备注外均为必填项': '除备注外均为必填项',
    '推送成功': 'Send Successfully'
  },
  button: {
    '确定': 'OK',
    '取消': 'Cancel',
    '关闭': 'Close',
    '预览': 'Preview',
    '提交': 'Submit',
    '返回': 'Back',
    '保存': 'Save',
    '导入': 'Import',
    '上传图片': 'Upload Image',
    '上传视频': 'Upload Video',
    '点击上传': 'Click to Upload',
    '保存草稿': 'Save as Draft',
    '删除图片': 'Delete Photos',
    '删除': 'Delete',
    '加图片': 'Add Photos',
    '加文字': 'Add Text',
    '全选': 'All',
    '新建': 'New',
    '添加': 'Add',
    '评价': 'Make Comments',
    '查看详细': 'View',
    '详情': 'Details',
    '反馈': 'Feedback',
    '下载': 'Download',
    '下载教委版': 'Download Gov',
    '搜索': 'Search',
    '关联': 'Association',
    '完成': 'Done',
    '保存并继续': 'Save & Continue',
    '新建文件夹': 'New folder',
    '查看': 'View',
    '查看详情': 'View',
    // ------------------------
    '编辑': 'Edit',
    '全员档案下载': 'Download all staff files',
    '一键通知缴费': 'One-click Payment ',
    '批量导入': 'Batch Import',
    '批量下载': 'Batch Download',
    '批量下载教委版': 'Batch Download Gov',
    '选取文件': 'Select Files',
    '上传': 'Upload',
    '设置': 'Set up',
    '查看封面图片': 'View Cover Pictures',
    '查看视频': 'View Videos',
    '新建系列': 'New Series',
    '新建视频': 'New videos',
    '预缴学费下载': '预缴学费下载',
    '通知全体教师': 'All Teachers',
    '通知全体教师和家长': 'All Teachers & Parents',
    '执行': 'Run',
    '查询': 'View'
  },
  date: {
    '今天': 'Today',
    '昨天': 'Yesterday',
    '一周前': 'Last week',
    '年': '-',
    '月': '-',
    '日': '',
    '选择月': 'Month',
    '至': ' to ',
    '开始日期': 'Start Date',
    '结束日期': 'End Date',
    '选择时间': 'Select the time',
    'YYYY年MM月': 'YYYY-MM',
    '请选择日期范围': 'Please select a date range' //
  },
  list: {
    '全部': 'All',
    '未评价': 'Unevaluated',
    '已评价': 'Evaluated',
    '草稿': 'Draft',
    '已发布': 'Submitted',
    '待评价': 'To be evaluated',
    '预备': 'Preparatory Class',
    '在校': 'At School',
    '已毕业': 'Graduated',
    '未反馈': 'No Feedback',
    '已反馈': 'Feedback Provided',
    '普通': 'Common',
    '校车': 'School Bus',
    '保健医': 'Doctor',
    '待完成': 'To be Done',
    '已完成': 'Done',
    '取消': 'Canceled',
    '待确认': 'To be Confirmed',
    '已确认': 'Confirmed',
    '确认': 'Confirm',
    '轶事记录': 'Class Observations',
    '教案': 'Lesson Plans',
    '已提交': 'Submitted',
    '请假': 'Absence',
    '销假': 'Exemption',
    '事假': 'Personal Leave',
    '病假': 'Sick Leave',
    '校车假': 'School bus',
    '未启用': 'Disable',
    '启用': 'Enable',
    '缴费': 'Payment',
    // ----------------------------
    '未通知缴费': 'Payment Unannounced',
    '已通知待缴费': 'Announced Pending Payment',
    '待缴费': 'Pending Payment',
    '已缴费': 'Already Paid',
    '未通知': 'Unannounced',
    '已缴费待确认': 'Payment to be Confirmed',
    '缴费项目': 'Payment Items',
    '其它': 'other',
    'IC卡号': 'IC Card No.',
    '家长或学生姓名': 'Parents’ or Students’ Names',
    '总金额：': 'Total Amount:',
    '自动算出的退费项目（非金额）': 'Automatically calculated refund items (non amount)',
    '自动算出的退费项目（金额）': 'Automatically calculated refund items (amount)',
    '未入账': 'Unrecorded',
    '已入账': 'Recorded',
    '审核未通过': 'Denied',
    '待审核': 'Waiting',
    '审核通过': 'Passed'
  },
  table: {
    '标题': 'Title',
    '序号': 'NO.',
    '幼儿园': 'Kindergarten',
    '班级': 'Class',
    '创建人': 'Creater',
    '创建时间': 'Creation Time',
    '状态': 'Status',
    '类型': 'Type',
    '操作': 'Operation',
    '名称': 'Title',
    '英文名称': 'English Title',
    '排序': 'Sorting',
    '托班': 'Pre class',
    '小班': 'Junior class',
    '中班': 'Middle class',
    '大班': 'Senior class',
    '选项': 'Options',
    '删除': 'Delete',
    '发布时间': 'Released Time',
    '发布人': 'Author',
    '校车老师': 'School Bus teacher',
    '校车': 'School bus',
    '提交家长': 'Parent',
    '查看付款人': 'View Drawee',
    // ------------------
    '学生所在班级': 'Class',
    '所属幼儿园': 'Kindergarten',
    '家长姓名': 'Name of Parent',
    '家长手机号': 'Parent’s Mobile Phone Number',
    '创建日期': 'Creation Date',
    '图片': 'Picture',
    '用户名称': 'User Name',
    '是否已启用': 'Is it enabled',
    '标准金额': 'Standard Amount',
    '折扣': 'Discount',
    '折后金额': 'Amount After Discount',
    '学费起止日': 'Start and End Dates of the Tuitions',
    '缴费截止日': 'Closing Date for Payment',
    '退费起止日': 'Start and End Date of the Refund',
    '缴费项目': 'Payment Items',
    '备注': 'Comments',
    '班级名称': 'Class Name',
    '学生姓名': 'Student Name',
    '金额': 'Amount',
    '付款人': 'Drawee',
    '模板': 'Template',
    '添加选项': 'Add Options',
    '自动退费核算': 'Automatic Refund Calculations',
    '作者': 'Author',
    '作者头衔': 'Title',
    '介绍': 'Introductions',
    '封面图片': 'Cover Picture',
    '视频时长': 'Video Duration',
    '教案文件(pdf)': 'File (pdf)',
    '备课视频(mp4)': 'Video (mp4)',
    '内容': 'Content',
    '日期': 'Date',
    '手机': 'Phone',
    '角色': 'Role',
    '集团': 'Group',
    '姓名': 'Name',
    '学生': 'Student',
    '开始月份': 'Start Month',
    '结束月份': 'End Month',
    '总金额': 'Total Amount',
    '已消费金额': 'Expenditure',
    '预缴费起止月': 'Start and End Months of the Tuitions'
  },
  form: {
    '学生': 'Student',
    '年龄': 'Age',
    '内容': 'Content',
    '集团': 'Group',
    '幼儿园': 'Kindergarten',
    '班级': 'Class',
    '日期': 'Date',
    '校车老师': 'School Bus teacher',
    '地点': 'Place',
    '视频': 'Video'
  },
  title: {
    '新建关联': 'New',
    '关联管理': 'Association',
    '新建': 'New',
    '编辑': 'Edit',
    // -----------------------------
    '时间': 'Time',
    '日饮水量': 'Hydration Reports',
    '水量': 'Water Intake',
    '幼儿园出勤基准天数': 'Day count of attendance',
    '学费自动生成设置': 'Tuition Fee Automatic Generation Set-up',
    '请确认缴费单': 'Please confirm the bill',
    '付款详情': 'Payment Details',
    '批量上传': 'Batch Upload',
    '添加学生与家长绑定': 'Add ‘student & parent’ binding'
  },
  message: { // ----------------------------
    '更新成功': 'Update Successful'
  },
  error: { // ----------------------------
    '请输入密码': 'Please enter a password',
    '两次密码必须一致': 'Inputed passwords must be same',
    '请输入手机号': 'Please enter your phone number ',
    '请选择集团': 'Please select Group',
    '请选择幼儿园': 'Please select kindergarten',
    '请选择班级': 'Please select class',
    '请选择角色': 'Please select a role',
    '请选择默认角色': 'Please select the default role'
  },
  tuitionbills: { // ----------------------------
    '支付宝': 'Alipay',
    '微信': 'WeChat',
    '二维码加载中，请稍候...': 'QR code loading, please wait...',
    '二维码加载失败，请关闭重试!': 'QR code is failed to load. Please close the page and try again',
    '请打开支付宝App扫码支付': 'Please use Alipay App and scan to pay.',
    '请打开微信扫码支付': 'Please use WeChat app and scan to pay',
    '请求金额': 'Request Amount',
    '已支付金额': 'Paid Amount',
    '元': 'Yuan',
    '查询金额合计': 'Total'
  },
  tuitionbillsdetail: { // ----------------------------
    '出勤情况：签到': 'Attendance Details: Sign in: ',
    '天': '',
    '请假': 'Request Leave: ',
    '项目名称：': 'Item Names:',
    '数值：': 'Number/Amount:',
    '日期': 'Date',
    '天数': 'Number of Days',
    '计费方法': 'Methods of Calculation'
  },
  tuitiondepositdetail: { // ----------------------------
    '已签到天数': 'Signed Day Count',
    '折扣内天数': 'Discount Signed Day Count',
    '折扣（% OFF）': 'Percent Off'
  },
  activity: {
    '教学策划': 'Teaching Strategies',
    '活动准备': 'Preparations',
    '活动描述': 'Descriptions',
    '活动地点': 'Locations',
    '活动日期': 'Date',
    '评量指标类别': 'Categories',
    '学生': 'Student',
    '标题': 'Title',
    '上一天': 'Prev',
    '下一天': 'Next',
    '教学记录选择': 'Teaching Records',
    '观察分析': 'Analysis',
    '省思': 'Summaries',
    '开放给家长': 'Share with Parents',
    '家长可见': 'Share with Parents',
    '标题内容编辑': 'Edit'
  },
  assessmentChecklists: {
    '评量清单指标关联编辑': 'Edit'
  },
  assessmentObjectives: {
    '选项名称：': 'Option Name: ',
    '英文名称：': 'Option in English: ',
    '分数：': 'Score: ',
    '排序：': 'Sorting: '
  },
  busTeacher: {
    '添加校车老师与校车绑定': 'Add "Teacher & School Bus" Binding',
    '校车老师': 'School Bus Teacher',
    '校车': 'School Bus',
    '请选择关联校车': 'Please select the associated school bus',
    '请选择校车老师': 'Please select a school bus teacher',
    '请选择校车': 'Please select school buses'
  },
  calendar: {
    '班级考勤表下载': 'Class Attendance Sheet Download',
    '全园考勤表下载': 'School Attendance Sheet Download',
    '签到数据下载': 'Attendance Data Download',
    '签到体温': 'TEMP.',
    '签退体温': 'TEMP.',
    '签到': 'Sign in',
    '签退': 'Sign out',
    '度': '°C',
    '请选择签到时间': 'Please select the time to sign in',
    '请选择签退时间': 'Please select the time to sign out'
  },
  calendarBus: {
    '早班': 'Morning',
    '早班不坐': 'Morning Absence',
    '晚班': 'Afternoon',
    '晚班不坐': 'Afternoon Absence',
    '全天': 'Whole day',
    '全天不坐': 'Whole Day Absence'
  },
  class: {
    '请输入班级名称': 'Please enter a class name',
    '年毕业)': ')',
    '(': '(Graduated in '
  },
  classCircle: {
    '班级圈': 'Moments',
    '班级圈上传': 'New',
    '上传图片的格式只能是JPG/PNG格式!': 'Format of uploading image can only be JPG / PNG!',
    '发布': 'Post'
  },
  doctorStudent: {
    '添加保健医与学生绑定': 'Add "Doctor & Student" Binding',
    '请选择关联学生': 'Please select students',
    '请选择保健医': 'Please select a doctor',
    '请选择保健医搜索': 'Please search by a doctor',
    '请选择名称': 'Please select a name',
    '名称': 'Name'
  },
  entrust: {
    '叮嘱状态': 'Status',
    '叮嘱类型': 'Types',
    '学生：': 'Students: ',
    '发布人：': 'Author: ',
    '发布时间：': 'Released Time: ',
    '确定要提交反馈吗？': 'Are you sure you want to submit the feedback?'
  },
  expertTeacher: {
    '添加专家与教师绑定': 'Add "Expert & Teacher" Binding',
    '请选择关联教师': 'Please select teachers',
    '请选择专家名称搜索': 'Please search by supervisor',
    '请选择专家': 'Please select a supervisor',
    '请选择教师': 'Please select teachers',
    '专家检索': 'Search by Supervisor',
    '教师检索': 'Search by Teacher',
    '专家集团': "Supervisor's Group",
    '专家幼儿园': "Supervisor's Kindergarten",
    '专家名称': 'Name of Supervisor',
    '老师名称': 'Name of Teacher',
    '老师幼儿园': "Teacher's Kindergarten",
    '老师班级': "Teacher's Class"
  },
  forms: {
    '园内模板': "Kindergarten's Templates",
    '公共模板': 'Public Templates',
    '查看模板': 'View Templates',
    '编辑模板': 'Edit Templates',
    '新建模板': 'New Templates'
  },
  tinymce: {
    '请等待上传成功。如果出现网络问题，请刷新页面并重新上传！': 'Please wait for uploading to succeed. Please refresh the page and upload again if there is any network errors.'
  },
  Group: {
    '集团名称': 'Group Name',
    '请输入集团名称': 'Please enter a Group name',
    '输入集团名称搜索': 'Please search by a Group name'
  },
  healthy: {
    '体温': 'Temperature',
    '晨检体温': 'Morning',
    '午检体温': 'Noon',
    '尿': 'Urine',
    '性状': 'Shape & Properties',
    '时间': 'Time',
    '第1次': 'First',
    '第2次': 'Second',
    '第3次': 'Third',
    '第4次': 'Fourth',
    '第5次': 'Fifth',
    '第6次': 'Sixth',
    '第7次': 'Seventh',
    '第8次': 'Eighth',
    '便': 'Faeces',
    '睡眠': 'Sleep',
    '睡眠情况': 'Sleep',
    '正常': 'Normal',
    '偏黄': 'Partial Yellow',
    '异常': 'Unusual',
    '绿黑色': 'Dark Green',
    '黄色(松软)': 'Yellow (soft)',
    '黄褐色': 'Yellowish-brown',
    '绿褐色': 'Greenish brown',
    '水样,褐色': 'Liquid Daeces, Brown',
    '干,褐色,硬': 'Dry, brown, hard',
    '粉红色,半消化的食物': 'Pink, Semi-digested Food',
    '深绿色、厚而黑': 'Dark Green, Thick & Black',
    '亮绿色、绿色多泡的': 'Light Green, Green & Bubbly',
    '带有红色血丝,带有血或粘液的干便': 'Bloodshot, Bloody & Mucinous Stool',
    '黑色、厚或柏油样': 'Black, Thick, Tarry Stool',
    '粉状、灰白色、无色或白色': 'Stool, Grayish White, Colourless or White',
    'Normal': 'Normal',
    'Partial Yellow': 'Partial Yellow',
    'Unusual': 'Unusual',
    'Dark Green': 'Dark Green',
    'Yellow (soft)': 'Yellow (soft)',
    'Yellowish-brown': 'Yellowish-brown',
    'Greenish brown': 'Greenish brown',
    'Liquid Daeces, Brown': 'Liquid Daeces, Brown',
    'Dry, brown, hard': 'Dry, brown, hard',
    'Pink, Semi-digested Food': 'Pink, Semi-digested Food',
    'Dark Green, Thick & Black': 'Dark Green, Thick & Black',
    'Light Green, Green & Bubbly': 'Light Green, Green & Bubbly',
    'Bloodshot, Bloody & Mucinous Stool': 'Bloodshot, Bloody & Mucinous Stool',
    'Black, Thick, Tarry Stool': 'Black, Thick, Tarry Stool',
    'Stool, Grayish White, Colourless or White': 'Stool, Grayish White, Colourless or White'
  },
  meal: {
    '奶量': 'Milk Intake',
    '早餐': 'Breakfast',
    '中餐': 'Lunch',
    '晚餐': 'Dinner',
    '水果': 'Fruit',
    '又添一份': 'Additional Portion',
    '全部吃完': 'Finish All',
    '吃一半': 'Finish Half',
    '多半': 'Finish More than Half',
    '吃一半（仅荤）': 'Finish All (meat only)',
    '吃一半（仅素）': 'Finish All (vegetables only)',
    '少量': 'A Little',
    '未食': 'Not Eaten',
    'Additional Portion': 'Additional Portion',
    'Finish All': 'Finish All',
    'Finish Half': 'Finish Half',
    'Finish More than Half': 'Finish More than Half',
    'Finish All (meat only)': 'Finish All (meat only)',
    'Finish All (vegetables only)': 'Finish All (vegetables only)',
    'A Little': 'A Little',
    'Not Eaten': 'Not Eaten'
  },
  kindergarten: {
    '省份': 'Provinces',
    '请选择省份': 'Please select a province',
    '城市': 'City',
    '区': 'Area',
    '详细地址': 'Detailed Address',
    '经度': 'Longitude',
    '纬度': 'Latitude',
    '合同起始日期': 'Contract Start Date',
    '合同终止日期': 'Contract End Date',
    '合同剩余天数': 'Remaining Days',
    '最大班级数': 'MAX number of classes',
    '请输入幼儿园名称搜索': "Please search by kindergarten's name",
    '请输入幼儿园名称': "Please enter a kindergarten's name",
    '版本': 'Version',
    '标准版': 'Standard',
    '轻量版': 'Lite',
    '托育版': 'Nurseries'
  },
  leaveNotes: {
    '假条类型': 'Types',
    '请假类型': 'Absence Types',
    '假条状态': 'Status',
    '校车时间': 'Time',
    '请假日期': 'Date',
    '校车假详情': 'Details',
    '提交时间': 'Submission Time',
    '审核': 'Approve',
    '事由': 'Reasons',
    '留言': 'Leave a Message',
    '姓名：': 'Name: ',
    '时间：': 'Time: ',
    '类型：': 'Type: ',
    '校车假详细：': 'Details: ',
    '状态：': 'Status: ',
    '学生家长：': 'Parents: ',
    '提交时间：': 'Submission time: ',
    '事由：': 'Reasons: ',
    '审核教师：': 'Approved by: ',
    '教师留言：': 'Messages from Teachers: ',
    '假条状态：': 'Status: ',
    '反馈：': 'Feedback: ',
    '【请假条】': 'Abense Notes',
    '【销假条】': 'Exemptions'
  },
  lesunFaceDevices: {
    '请选择状态搜索': 'Please search by status',
    '姓名': 'Name',
    '状态码': 'Status Code',
    '错误信息': 'Error Message',
    '失败': 'Fail',
    '成功': 'Successful',
    '设备': 'Equipment',
    '请输入设备序列号': 'Please enter the device serial number',
    '刷新列表': 'Refresh List',
    '设备序列号': 'Device Serial Number',
    '绑定幼儿园': 'Binding to a kindergarten',
    '下发': 'Send',
    '下发QR': 'Send QR',
    '下发结果': 'Results',
    '离线': 'Off-line',
    '上线': 'Online',
    '确定要下发吗？': 'Are you sure you want to send the data?',
    '已开始下发！请稍候查看下发结果！': 'Distribution started! Please check the distribution results later!'
  },
  mood: {
    '请选择情绪': 'Please select the mood',
    '非常好': 'Very Good',
    '稳定': 'Stable',
    '分离焦虑': 'Separation Anxiety',
    'Very Good': 'Very Good',
    'Stable': 'Stable',
    'Separation Anxiety': 'Separation Anxiety'
  },
  notice: {
    '通知': 'Announcements',
    '照片': 'Photo',
    '发布': 'Send',
    '上传成功': 'Upload successfully',
    '附件上传': 'Upload Attachments',
    '请先保存草稿': 'Please save as draft first',
    '将文件拖到此处，或': 'Drag the file here, or',
    '请选择通知对象': 'Please select an object',
    '请输入通知内容': 'Please enter the content',
    '图片传输中……': 'Picture Uploading',
    '上传图片失败': 'Picture Uploading Failed',
    '上传图片的格式只能是JPG/MP4/PNG格式！': 'Format of uploading image can only be JPG / MP4 / PNG!',
    '图片删除成功': 'Picture Deleted Successfully',
    '图片删除失败': 'Picture Deleted Failed',
    '确定要发送通知吗？': 'Are you sure you want to release?',
    '确定要通知未读人吗？': 'Are you sure you want to inform the unread?',
    '通知未读人': 'Inform The Unread',
    '通知未读人成功': 'Informed successfully',
    '未读人': 'Unread',
    '新建富文本通知': 'New Rich Text Annoucement',
    '新建简易通知': 'New Simple Annoucement'
  },
  predesignTeachingPlan: {
    '查看教案文件': 'View Files',
    '查看教案视频': 'View Videos',
    '文件格式错误': 'File Format Error',
    '必须在相同集团添加或修改': 'Must be added or modified in the same Group',
    '请上传pdf文件': 'Please upload PDF file',
    '班级绑定设置': 'Class Binding Set-up',
    '班级绑定清空': 'Clear Class Binding',
    '是否清空已选班级设置？': 'Are you sure to clear secleted classes?',
    '班级关联清除成功': 'Class binding cleared successfully',
    '请选择教案': 'Please select lesson plans'
  },
  principalKindergarten: {
    '添加园长与幼儿园绑定': 'Add "Principal & Kindergarten" Binding',
    '请选择关联幼儿园': 'Please select related kindergartens'
  },
  refundCaculations: {
    '餐费': 'Meals Fees',
    '退费方法': 'Refund Calculation Method',
    '请选择退费方法': 'Please select a refund calculation method',
    '月标准价格': 'Monthly Standard Price',
    '每日价格': 'Daily Price',
    '四舍五入方法': 'Calcuation Methods',
    '请选择四舍五入计算方法': 'Please select a calculation method',
    '价格不能小于等于0': 'Price cannot be less than or equal to zero',
    '退费方法不能为空': 'Please select a refound calculation method',
    '四舍五入方法不能为空': 'Please select a calculation method',
    '精算（按月参考天数计算单价）': 'Accurate Calculation (unit price calculated by actual school days)',
    '每日固定金额': 'Daily Fixed Amount',
    '无四舍五入精确到分': 'No round up and round down nearest to Fen',
    '四舍五入精确到元': 'Round up and round down nearest to Yuan'
  },
  register: {
    '注册': 'Register',
    '重置': 'Reset',
    '确认密码': 'Confirm Password',
    '幼儿园注册码': 'Kindergarten Registration Code',
    '获取班级列表': 'Obtain Class List',
    '短信验证码': 'Code',
    '获取短信验证码': 'Code',
    '请再次输入密码': 'Please enter the password again',
    '两次输入密码不一致！': 'Inputed passwords are not same',
    '请输入幼儿园注册码': 'Please enter kindergarten registration code',
    '请输入姓名': 'Please enter your name',
    '请输入短信验证码': 'Please enter the code',
    '注册成功！': 'Registered Successfully'
  },
  schoolBus: {
    '站点名称': 'Station Name',
    '站点不停靠': 'No Stopping at this station',
    '早上到达时间': 'Arriving Time (Morning)',
    '晚上到达时间': 'Arriving Time (Afternoon)',
    '校车名称': 'School Bus Name',
    '添加校车': 'Add School Bus',
    '(早班)': '(Morning)',
    '(晚班)': '(Afternoon)',
    '无': 'None',
    '编辑校车': 'Edit ‘School Bus’',
    '添加站点': 'Add a Station',
    '跟车教师一': 'Car Heel Teacher 1',
    '跟车教师二': 'Car Heel Teacher 2',
    '跟车教师一：': 'Car Heel Teacher 1：',
    '跟车教师二：': 'Car Heel Teacher 2：'
  },
  schoolBusDownload: {
    '叮嘱下载': 'Notifications Data Download',
    '请假下载': 'Absence Notes Data Download'
  },
  statistics: {
    '基本统计': 'Basic Statistics',
    '用户:': 'User:',
    '活跃用户:': 'Active Users:',
    '幼儿园:': 'kindergarten:',
    '园长:': 'Principal:',
    '专家:': 'Supervisor:',
    '教师:': 'Teacher:',
    '校医:': 'Doctor:',
    '校车老师:': 'School Bus Teacher:',
    '轶事记录总数:': 'Total Number of Learning Stories:',
    '教案总数:': 'Total Number of Lesson Plans:',
    '图片总数:': 'Total Number of Pictures:',
    '家长:': 'Parents:',
    '学生:': 'Students:',
    '已毕业学生:': 'Graduated Students:',
    '时间范围统计': 'Time Frame Statistics',
    '新增轶事记录:': 'Add Class Observations:',
    '新增教案:': 'Add Lesson Plans:',
    '新增图片:': 'Add Pictures:',
    '故事阅读量统计': 'Stories Hits Statistics',
    '幼儿园管理员:': 'Kindergarten Admin:',
    '阅读数': 'Reading Hits'
  },
  student: {
    '学生通讯录下载': 'Student Address Book Download',
    '学生名单导入': 'Student Import',
    '二维码下载': 'QR Code Download',
    '二维码重置并下载': 'QR Code Reset and Download',
    '填表人签字': 'Signature',
    '学生信息': 'Student Information',
    '幼儿1寸照片': 'Kid’s One-inch photo ',
    '父亲1寸照片': '父亲1寸照片',
    '母亲1寸照片': '母亲1寸照片',
    '学生姓名': 'Student Name',
    '性别': 'Gender',
    '学生状态': 'Student Status',
    '父亲姓名': "Father's Name",
    '电话': 'Phone Number',
    '母亲姓名': "Mother's Name",
    '昵称': 'Nickname',
    '生日': 'Date of Birth',
    '身份证号码': '身份证号码',
    '身份证/护照': '身份证/护照',
    '国籍': '国籍',
    '出生地': '出生地',
    '家庭地址': 'Address',
    '家庭电话': '家庭电话',
    '邮编': '邮编',
    '身体健康信息': '身体健康信息',
    '病症名称': '病症名称',
    '是': '是',
    '否': '否',
    '发觉该病时的年龄': '发觉该病时的年龄',
    '贫血症': '贫血症',
    '糖尿病': '糖尿病',
    '阑尾炎': '阑尾炎',
    '腮腺炎': '腮腺炎',
    '哮喘': '哮喘',
    '小儿麻痹症': '小儿麻痹症',
    '骨裂': '骨裂',
    '外科手术': '外科手术',
    '水痘': '水痘',
    '风湿热': '风湿热',
    '麻疹（10日风疹）': '麻疹（10日风疹）',
    '风疹': '风疹',
    '白喉': '白喉',
    '猩红热': '猩红热',
    '耳部感染': '耳部感染',
    '痉挛或惊厥': '痉挛或惊厥',
    '湿疹': '湿疹',
    '扁桃腺炎': '扁桃腺炎',
    '癫痫症': '癫痫症',
    '扁桃腺切除': '扁桃腺切除',
    '腺体热': '腺体热',
    '肺结核': '肺结核',
    '干草热': '干草热',
    '百日咳': '百日咳',
    '心脏病或心脏杂音': '心脏病或心脏杂音',
    '其他': '其他',
    '你的孩子是否对某种药物过敏': '你的孩子是否对某种药物过敏',
    '过敏药物种类及症状': '过敏药物种类及症状',
    '紧急治疗建议': '紧急治疗建议',
    '你的孩子是否对某种食物过敏': '你的孩子是否对某种食物过敏',
    '过敏食物种类及症状': '过敏食物种类及症状',
    '你的孩子是否有其他过敏': '你的孩子是否有其他过敏',
    '过敏源及症状': '过敏源及症状',
    '您的孩子是否有视觉缺陷': '您的孩子是否有视觉缺陷',
    '您的孩子是否有听觉缺陷': '您的孩子是否有听觉缺陷',
    '您的孩子是否接受过语言能力治疗': '您的孩子是否接受过语言能力治疗',
    '你的孩子是否接受过行为控制治疗': '你的孩子是否接受过行为控制治疗',
    '您的孩子是否有学习能力障碍': '您的孩子是否有学习能力障碍',
    '您的孩子是否经常或周期性地接受药物治疗': '您的孩子是否经常或周期性地接受药物治疗',
    '您的孩子是否还有其他的医疗病史': '您的孩子是否还有其他的医疗病史',
    '您的孩子是否有饮食禁忌': '您的孩子是否有饮食禁忌',
    '其它细节': '其它细节',
    '若您的孩子不适合参加户外运动、体育课程或其他运动，请在以下注明，并提交一份有关的体格证明，以供园方参考:': '若您的孩子不适合参加户外运动、体育课程或其他运动，请在以下注明，并提交一份有关的体格证明，以供园方参考:',
    '若您的孩子因宗教信仰或其他非药物原因，在饮食上有别的要求，请注明:': '若您的孩子因宗教信仰或其他非药物原因，在饮食上有别的要求，请注明:',
    '肖像使用确认事宜': '肖像使用确认事宜',
    '官网、微博（内部）使用': '官网、微博（内部）使用',
    '同意': '同意',
    '不同意': '不同意',
    '宣传刊物（校内和校外）使用': '宣传刊物（校内和校外）使用',
    '企业宣传片使用': '企业宣传片使用',
    '户外大型广告使用': '户外大型广告使用',
    '你愿意到幼儿园来参加有关您所庆祝节日的活动吗？包括讲故事，唱歌或者其他类型的一些活动。': '你愿意到幼儿园来参加有关您所庆祝节日的活动吗？包括讲故事，唱歌或者其他类型的一些活动。',
    '你愿意义务帮助组织或者在幼儿园出游时帮助照看我们的孩子吗？': '你愿意义务帮助组织或者在幼儿园出游时帮助照看我们的孩子吗？',
    '父亲详细信息': '父亲详细信息',
    '身份证号': '身份证号',
    '目前单位与职位': '目前单位与职位',
    '母语': '母语',
    '单位地址': '单位地址',
    '单位电话': '单位电话',
    '单位传真': '单位传真',
    '电子邮件': '电子邮件',
    '微信号': '微信号',
    '备注': 'Comments',
    'Comments': 'Comments',
    '母亲详细信息': '母亲详细信息',
    '兄弟姐妹信息': '兄弟姐妹信息',
    '目前所在幼儿园': '目前所在幼儿园',
    '女': 'Female',
    '男': 'Male',
    '家庭语言信息': '家庭语言信息',
    '曾就读园所': '曾就读园所',
    '地址': '地址',
    '该园的教育语言': '该园的教育语言',
    '孩子的母语': '孩子的母语',
    '其他可交流语言': '其他可交流语言',
    '母亲的母语': '母亲的母语',
    '父亲的母语': '父亲的母语',
    '家庭所用语言': '家庭所用语言',
    '您如何评价您孩子的英语水平：': '您如何评价您孩子的英语水平：',
    '您的孩子在园外是否参加语言学习？如有，请注明：': '您的孩子在园外是否参加语言学习？如有，请注明：',
    '紧急联系人': 'Emergency Contact',
    '第一紧急联系人（除家长）': 'Primary Emergency Contact (except the parents)',
    '与孩子的关系': 'Relationship with the kids',
    '移动电话': 'Mobile Phone Number',
    '工作电话': 'Work Phone Number',
    '第二紧急联系人（除家长）': 'Secondary Emergency Contact (except parents)',
    '首选医院名称': 'Preferred Hospital',
    '若园方无法联络到上述联系人，请在下列注明家长希望把孩子送至紧急治疗的医院或诊所名称（首选医院名称）': 'If the above contact persons cannot be reached, please indicate the name of the hospital or the clinic where the parents are willing to send the kids for emergency treatment (preferred hospital name or clinic)',
    '请注意：若家长不指定任何医院，或指定的医院并没有所需之治疗服务，园方将根据紧急情况将孩子送往就近最合适的医院。': 'Please note: if the parents do not appoint any hospital or the designed hospital does not have the necessary treatment, we are going to send the kid to the nearest and most suitable hospital according to the emergency situation.',
    '孩子是否持有医疗和意外保险？如果有，请填入保险信息': 'Does the kid have any medical and accident insurance? If yes, please fill in the insurance information',
    '有': 'Yes',
    '没有': 'No',
    '保险公司': 'Insurance Company',
    '保险单号码': 'Insurance Policy Number',
    '保险项目': 'Insurance Items',

    '校车申请及其他信息': '校车申请及其他信息',
    '搭乘校车': '搭乘校车',
    '不需要': '不需要',
    '需要': '需要',
    '搭乘种类': '搭乘种类',
    '双程': '双程',
    '搭车去幼儿园': '搭车去幼儿园',
    '搭车回家': '搭车回家',
    '接送地址': '接送地址',
    '您的孩子对食物有没有特殊的要求？': '您的孩子对食物有没有特殊的要求？',
    '您的家庭庆祝什么节日？（国家或民族的特别节日）': '您的家庭庆祝什么节日？（国家或民族的特别节日）',
    '您的孩子有宠物吗？': '您的孩子有宠物吗？',
    '您的孩子在睡觉时有喜欢的玩具吗？': '您的孩子在睡觉时有喜欢的玩具吗？',
    '请输入填表人签字': 'Please sign',
    '全部': 'All',
    '在校': 'At School',
    '休学': 'Suspension of Schooling',
    '毕业': 'Graduated',
    '退学(已退费)': 'Quit School (Refunded)',
    '退学(未退费)': 'Quit School (Not Refunded)',
    '学生档案导入模板下载': '学生档案导入模板下载'
  },
  national: {
    '中国': '中国',
    '美国': '美国',
    '加拿大': '加拿大',
    '澳大利亚': '澳大利亚',
    '英国': '英国',
    '法国': '法国',
    '德国': '德国',
    '意大利': '意大利',
    '俄罗斯': '俄罗斯',
    '巴西': '巴西',
    '印度': '印度',
    '希腊': '希腊',
    '爱尔兰': '爱尔兰',
    '西班牙': '西班牙',
    '日本': '日本',
    '瑞士': '瑞士'
  },
  language: {
    '汉语': '汉语',
    '英语': '英语',
    '意大利语': '意大利语',
    '俄语': '俄语',
    '日语': '日语',
    '爱尔兰语': '爱尔兰语',
    '希腊语': '希腊语',
    '德语': '德语',
    '西班牙语': '西班牙语',
    '瑞士语': '瑞士语',
    '葡萄牙语': '葡萄牙语'
  },
  studentAssessments: {
    '语言': 'Language',
    '请选择年龄': 'Please Select Age',
    '请选择评量时间': 'Please Select Time',
    '切换语言': 'Switch Languages',
    '2岁': '2',
    '2岁半': '2.5',
    '3岁': '3',
    '3岁半': '3.5',
    '4岁': '4',
    '4岁半': '4.5',
    '5岁': '5',
    '5岁半': '5.5',
    '6岁': '6',
    '岁': ' year(s) old',
    '学年初(Beginning)': 'Beginning of School Year',
    '学年初': 'Beginning of School Year',
    '学年中(Middle)': 'Middle of School Year',
    '学年中': 'Middle of School Year',
    '学年末(End)': 'End of School Year',
    '学年末': 'End of School Year',
    '托班(Pre)': 'Pre-Class',
    '小班(Junior)': 'Junior Class',
    '中班(Middle)': 'Middle Class',
    '大班(Senior)': 'Senior Class',
    '查看评量依据': 'View the Evidence for the Assessment',
    '语言(language):': 'Language:',
    '选择题库：': 'Programme:',
    '题库': 'Programme',
    '评量时间': ' Time for Assessment',
    '评量方案': 'Programme for Assessment',
    '评量结果图': 'Result Chart',
    '评量对比图': 'Comparison Chart',
    '选择题库:': 'Programme'
  },
  tuitionBillsTemplates: {
    '从学费档案导入': "Import from files of 'tuition fees'",
    '导入到缴费项目': 'Import into payment items'
  },
  optionalFunction: {
    '上传原图': '上传原图',
    '显示托婴': '显示托婴',
    '显示监控': '显示监控',
    '隐藏教案': '隐藏教案',
    '隐藏家庭作业': '隐藏校外活动',
    '隐藏评量': '隐藏评量',
    '显示教研培训': '显示教研培训',
    '隐藏服药单': '隐藏服药单',
    '隐藏学员手册': '隐藏学员手册',
    '显示表格管理': '显示表格管理',
    '隐藏预设教案': '隐藏预设教案',
    '隐藏校车': '隐藏校车',
    '隐藏招生': '隐藏招生',
    '教学记录个数限制': '教学记录个数限制',
    '班级圈发布次数限制': '班级圈发布次数限制',
    '视频时长限制（秒）': '视频时长限制（秒）',
    '显示工资单': '显示工资单',
    '显示预缴学费管理': '显示预缴学费管理',
    '隐藏健康日报': '隐藏健康日报',
    '隐藏学费单': '隐藏学费单',
    '显示轶事记录-观察分析': '显示轶事记录-观察分析',
    '隐藏教学记录': '隐藏教学记录',
    '隐藏学生作品': '隐藏学生作品',
    '隐藏班级圈照片': '隐藏班级圈照片',
    '显示轶事记录下载教委版': '显示轶事记录下载教委版',
    '隐藏签到': '隐藏签到',
    '隐藏请销假': '隐藏请销假',
    '隐藏叮嘱': '隐藏叮嘱',
    '隐藏关怀问候': '隐藏关怀问候',
    '显示我的助手': '显示我的助手',
    '我的助手会话次数限制': '助手会话次数限制'
  },
  ysCamera: {
    '设备名称': '设备名称',
    '请输入设备名称': '请输入设备名称',
    '直播地址': '直播地址',
    '提示：数字越大越靠前': '提示：数字越大越靠前',
    '请输入直播地址': '请输入直播地址'
  },
  punch: {
    'WiFi名称': 'WiFi Name',
    'Mac地址1': 'MAC Address 1',
    'Mac地址2': 'MAC Address 2',
    'Mac地址3': 'MAC Address 3',
    'Mac地址4': 'MAC Address 4',
    'Mac地址5': 'MAC Address 5',
    '工作开始时间': 'Working Start Time',
    '工作结束时间': 'Working End Time',
    '启用': 'Enable',
    '停用': 'Disable',
    '已启用': 'Enabled',
    '已停用': 'Disabled',
    '启用提示': 'After enabling, the mobile terminal will display the punch in function. Please remind teachers to punch in',
    '停用提示': 'After disabling, the mobile terminal will no longer display the clock out function. Are you sure you want to disable it?',
    'WiFi名称提示': 'It can be viewed in the WiFi settings of the mobile phone',
    'Mac提示': 'You can download Tencent WiFi manager app from your mobile phone to view it. Format：xx:xx:xx:xx:xx:xx',
    'WiFi名称PlaceHolder': 'Please input WiFi Name',
    'Mac地址PlaceHolder': 'Please input MAC Address',
    '工作开始时间PlaceHolder': 'Please select Working Start Time',
    '工作结束时间PlaceHolder': 'Please select Working End Time',
    '请选择月份': 'Please choose month',
    '外勤': 'Outside',
    '迟到': 'Late',
    '早退': 'Early',
    '打卡记录下载': 'Download'
  },
  personalInfoProtection: {
    '个人信息保护': 'Personal Info Protection',
    '数据处理': 'Data Processing',
    '已毕业学生档案脱敏': 'Desensitization of graduated student files',
    '数量': 'Count:',
    '已毕业学生家长删除': 'Delete parent accounts of graduated students',
    '已毕业班级教学记录删除': 'Delete teaching record of graduated class',
    '已毕业班级班级圈删除': 'Delete class circle message of graduated class',
    '执行确认': 'Are you sure you want to run this operation?',
    '执行成功': 'Run successfully',
    '已毕业学生数据删除': 'Delete graduated students data',
    '任务创建成功，系统将在夜间自动处理': 'Task is created successfully, system will process it automatically at night',
    '请选择需要删除的数据': 'Please select the data to delete',
    '删除选择日期之前的校园通知': 'Delete notices before the date',
    '校园通知删除': 'Delete notices'
  },
  resetPassword: {
    '重置密码': 'Reset Password',
    '保存成功': 'Reset Successfully',
    '忘记密码': 'Forgot Password?',
    '请重置密码': 'Please reset password'
  },
  admission: {
    '招生': 'Admission',
    '收费标准': 'Charging Standard',
    '起始日期': 'Start Date',
    '请选择起始日期': 'Please select start date',
    '学费（人）-国际班': 'Tuition-IK',
    '月缴费价格': 'Month',
    '学期缴费价格（5个月）': 'Term',
    '学年缴费价格（10个月）': 'Year',
    '学费（人）-双语班': 'Tuition-BK',
    '学费（人）-混龄班': 'Tuition-MA',
    '一次性费用': 'One Time Cost',
    '餐费': 'Meal Fee',
    '餐费规格': 'Meal Standard',
    '校车费（人/月）此处公里数为往返总公里数': 'Bus Fee',
    '10公里内': '10KM or Under',
    '10-20公里': '10-20KM',
    '20公里以上': '20KM or More',
    '定金费用': 'Deposit',
    '备注': 'Comments',
    '收费项目': 'Charge Items',
    '折扣政策': 'Discount Policy',
    '保教费-双语班': 'Tuition-BK',
    '保教费-国际班/混班': 'Tuition-IK/MA',
    '伙食费': 'Meal Fee',
    '校车费': 'Bus Fee',
    '入学一次性费用': 'One Time Cost',
    '代办费': 'Commission',
    '其他': 'Others',
    '对外': 'Outside',
    '员工': 'Employee',
    '特殊': 'Special',
    '汇总下载': 'Gather Download',
    '班级状况': 'Class Situation',
    '满园人数': 'Capacity',
    '应出勤人数': 'Should be Present',
    '招生目标人数': 'Objective',
    '实际出勤人数': 'Actual Attendance',
    '小班双语班': 'K1 Bilingual Class',
    '小班国际班': 'K1 International Class',
    '中班双语班': 'K2 Bilingual Class',
    '中班国际班': 'K2 International Class',
    '大班双语班': 'K3 Bilingual Class',
    '大班国际班': 'K3 International Class',
    '托班双语班': 'BPrek Bilingual Class',
    '托班国际班': 'BPrek International Class',
    '班级数': 'Class Count',
    '满班学生数': 'Student Capacity',
    '当前学生数': 'Present Student',
    '新开班型': 'New Class Type',
    '新开班级数及最新人数': 'New Class & Student Count',
    '空余教室': 'Empty Class',
    '教室数量': 'Class Count',
    '招生年度计划': 'Annual Plan',
    '输入年搜索': 'Enter year for search',
    '年度': 'Year',
    '请输入年度': 'Please enter a year',
    '现有班型': 'Existing Class Type',
    '在册人数': 'Registered',
    '1月在园人数': 'In Jan',
    '12月计划在园人数': 'In Dec',
    '第一季度': 'First Quarter',
    '第二季度': 'Second Quarter',
    '第三季度': 'Third Quarter',
    '第四季度': 'Fourth Quarter',
    '计划招生人数': 'Planned Enrollment',
    '实际招生人数': 'Actual Enrollment',
    '计划入园人数': 'Planned In',
    '实际入园人数': 'Actual In',
    '7月份毕业班数': 'Gratuate Class',
    '7月份毕业人数': 'Gratuate Student',
    '9月份预计开班数': 'New Class',
    '请在年度搜索输入后点击下载': 'Please enter a year',
    '客户线索与商机': 'Clue & Opportunity',
    '月份': 'Month',
    '线索数': 'Clue',
    '商机数': 'Opportunity',
    '去年季度同比汇总下载': 'Download',
    '请输入线索': 'Please input clue count',
    '请输入商机': 'Please input opportunity count',
    '客户来源分析': 'Customer Source Analysis',
    '季度分析汇总下载': 'Download',
    '仅推荐补历史数据时填写，不填写则系统会自动算出人数': 'It is only recommended to fill in the supplementary historical data. If it is not filled in, the system will automatically calculate the number',
    '招生计划完成率汇总下载': 'Completion Rate Download',
    '实际招生人数分析': 'Actual Enrollment Analysis',
    '年度实际招生人数下载': 'Download by Year',
    '近3年月度同比分析汇总下载': 'Month Gather Download',
    '近3年季度同比分析汇总下载': 'Quarter Gather Download',
    '客户信息': 'Customer Info',
    '潜在生来访分析及跟进记录下载': 'Potential Students Download',
    '请选择参观日期范围': 'Please select visit date range',
    '联系人': 'Contact Person',
    '负责人': 'Teacher',
    '全部': 'All',
    '新客户': 'New Customer',
    '建立联系': 'Make Connections',
    '参观园所': 'Campus Tours',
    '预定学位': 'Reserve Places',
    '缴纳学费': 'Pay Tuition',
    '姓名、联系电话检索': 'Name、Phone Search',
    '商机状态': 'Business State',
    '商机未关闭': 'Unconcluded',
    '商机成功': 'Success',
    '商机失败': 'Failed',
    '自己负责': 'Mine',
    '其他老师负责': 'Others',
    '请输入宝宝姓名': 'Please enter kid\'s name',
    '宝宝姓名': 'Kid\'s Name',
    '小名': 'Nick Name',
    '民族': 'Nation',
    '联系人姓名': 'Contact Person',
    '和宝宝关系': 'Relationship',
    '联系人电话': 'Contact\'s Phone',
    '预约班级': 'Reserved Class',
    '是否坐校车': 'School Bus',
    '客户来源': 'Source',
    '状态': 'State',
    '商机关闭原因': 'Reason',
    '请选择客户来源': 'Please select source',
    '预约记录': 'Appointment Records',
    '沟通记录': 'Communication Records',
    '优惠券': 'Coupons',
    '沟通日期': 'Date',
    '已处理': 'Addressed',
    '未处理': 'Unaddressed',
    '是否电话交流': 'Communicate by Phone',
    '预约参观': 'Appointment for Tours',
    '预约试听课': 'Appointment for Audition',
    '退园人数分析': 'Drop Out Analysis',
    '年度退园人数下载': 'Download by Year',
    '业财对账': 'Reconciliation',
    '姓名检索': 'Name Search',
    '老生退款信息追加': 'Add Student Refund Info',
    '待业务处理': 'Pending by Admission',
    '待财务处理': 'Pending by Financial',
    '财务已处理': 'Done',
    '注意：此功能只用于未在客户信息内录入过的学生': 'Note: students who have previously performed reconciliation can edit the records and add refund information. This function is only used for students who have not entered in customer information and have not performed reconciliation',
    '定金金额': 'Deposit',
    '定金转全款金额': 'Deposit to Full',
    '全款金额': 'Full Amount',
    '招生确认': 'Admission',
    '财务确认': 'Financial',
    '折扣率': 'Discount Rate',
    '折扣金额': 'Discount',
    '退定金金额': 'Refund Deposit',
    '退全款金额': 'Refund Full Amount',
    '已入园退全款金额': 'Refund',
    '请输入金额': 'Please enter a amount',
    '请打勾': 'Please check',
    '请输入姓名': 'Please enter a name',
    '入园日期': 'Student In Date',
    '周报': 'Weekly Report',
    '提交人': 'Committer',
    '提交日期': 'Commit Date',
    '报告日期': 'Date',
    '以下为系统自动计算': 'The following is calculated automatically by the system',
    '在园人数': 'In School',
    '新入园人数': 'New Student',
    '交订金转全款人数': 'Deposit to Full',
    '交订金人数': 'Deposit',
    '交全款人数': 'Full Amount',
    '退订金人数': 'Refund Deposit',
    '退全款人数': 'Refund Full',
    '退园人数': 'Drop Out',
    '搜集潜在生名单人数': 'New Customer',
    '来园参访人数': 'Visit',
    '电话咨询人数': 'Phone',
    '夏季毕业人数': 'Graduated',
    '高意向人数': 'Inclination',
    '夏季预计毕业人数': 'Estimate Graduate',
    '招生宣讲次数': 'Publicity',
    '校内试听课次数': 'Audition',
    '举办校外推广次数': 'Promotion',
    '班型详细说明': 'Class Type',
    '学费信息': 'Tuition',
    '退定金、退全款、退园分析': 'Refund Comment',
    '成功经验总结': 'Successful Experience',
    '下周重点工作安排': 'Arrangement',
    '班级数为在校班级总数': 'The total number of classes in school',
    '在校加休学人数': 'Number of students in school and out of school',
    '在校人数': 'Number of students in school',
    '以第一次签到日期计算': 'Calculated based on the first sign-in date',
    '通过业财对账数据统计': 'Through business finance reconciliation data',
    '新增客户数': 'Number of new customers',
    '时间段内状态变更为参观园所的客户数量': 'Number of customers whose state changes to visit during the time period',
    '时间段内状态变更为建立联系的客户数量': 'Number of customers whose state changes to contact during the time period',
    '6月1日至8月31日之间内状态变更为毕业的学生人数': 'Number of students whose state changed to graduation from June 1 to August 31',
    '请填写此项': 'Please input',
    '招生周数据统计下载': 'Download',
    '请选择统计日期范围': 'Please select the date range',
    '保存后请进行业财对账': 'Please perform finance reconciliation after saving',
    '意向度': 'Intention',
    '1-10分，越大意向越高': '1-10 points, the greater the intention',
    '园所': 'Kindergarten',
    '预约待处理': 'Appointment',
    '没有负责人': 'No one in charge',
    '未知': 'Unknown'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js